<script>

    import { replace } from 'svelte-spa-router'
    import { adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import View from '../$layouts/view.layout.svelte'
    import PageHeader from '../$components/page.header.svelte'
    import Modal from '../$components/modal.container.svelte'
    import NotificationsComponent from './component.notifications.svelte'
    import NotificationComponent from './component.notification.svelte'
    import NotificationCreateComponent from './component.create.svelte'
    import NotificationUpdateComponent from './component.update.svelte'

    if(!isPermission($adminStore, 'TracingsView.Notifications.View'))
        replace('/404')

</script>

<View>
    <PageHeader title="Notificaciones" subtitle="Notificaciones globales del sistema" />
    <NotificationsComponent query={{type: 'global'}} />
</View>

<Modal id="notification_create_modal" title="Notificación Global" >
    <NotificationCreateComponent type='global' />
</Modal>

<Modal id="notification_modal" title="Notificación Global" >
    <NotificationComponent />
</Modal>

<Modal id="notification_update_modal" title="Notificación Global" >
    <NotificationUpdateComponent />
</Modal>
